/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:screenUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/10/19 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/08/03 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
 */
import router from '@/router/router.js';
import store from '@/store/store.js';
import {
	STORE_VIEW_BROWSER_BACK,
	STORE_VIEW_ADD_VIEW_PARAMS,
	STORE_VIEW_DELETE_PARAMS,
} from '@/const/store.js';

/*
 * ページトップ移動
 */
export function co_toTop() {
	window.scrollTo({
        top: 0,
        behavior: 'auto'
    })
}

/*
 * 画面遷移
 * @param {String} path 画面URL
 * @param {Object} params 画面間受け渡しパラメータ
 */
export function co_toTrans(path, params = null) {

	// 画面間パラメータを登録
	if (params != null) {
		store.commit(STORE_VIEW_ADD_VIEW_PARAMS, {id:path, params: params});
	}

	// 画面遷移
	router.push(path);

	// 画面遷移制御
	co_toTransCtrl();
}

/*
 * 画面遷移制御
 */
export function co_toTransCtrl() {

	store.commit(STORE_VIEW_BROWSER_BACK, false);

	window.setTimeout(() => {
		store.commit(STORE_VIEW_BROWSER_BACK, true);
	}, 500)
}

/*
 * 画面間パラメータ削除
 * @param {String} path 画面URL
 */
export function co_clearParam(path) {

	// 画面間パラメータを削除
	store.commit(STORE_VIEW_DELETE_PARAMS, path);
}